import axiosPublicClient from "../../../../../../../../axiosPublicClient"
import axiosClient from "../../../../../../../../axiosClient"

export default async (data) => {

    if (data.key) {
        const result = await axiosPublicClient.post(`/generate-consent`, data)

        return result.data
    }

    const result = await axiosClient.post(`/generate-consent`, data)

    return result.data

}
